import { render, staticRenderFns } from "./AccountSettingGeneral.vue?vue&type=template&id=568d85da&scoped=true&"
import script from "./AccountSettingGeneral.vue?vue&type=script&lang=js&"
export * from "./AccountSettingGeneral.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingGeneral.vue?vue&type=style&index=0&id=568d85da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568d85da",
  null
  
)

export default component.exports